export default class ProductEnum {
    static SCHOOL = 1
    static OFFICE = 2
    static APRENDA_ADVOGAR = 3
    static QUIZ = 4
}